import React, { ReactNode } from 'react';
import classNames from 'classnames';

import styles from './styles.module.scss';

interface Props {
  imageUrl?: string;
  backgroundContent?: React.ReactNode;
  children: ReactNode;
  backgroundHeight?: string;
}

const BlurredBackgroundSection: React.FC<Props> = ({
  imageUrl,
  backgroundContent,
  children,
  backgroundHeight
}) => {
  const backgroundImageStyle = imageUrl
    ? {
        backgroundImage: `url(${imageUrl})`,
        backgroundSize: 'cover'
      }
    : null;

  const backgroundStyle = {
    ...backgroundImageStyle,
    ...(backgroundHeight && { height: backgroundHeight })
  };

  const gradientStyle = backgroundHeight ? { height: backgroundHeight } : {};

  return (
    <div className="relative">
      <div
        className={classNames(
          'z-0 absolute top-0 left-0 right-0 bg-primary-200 flex justify-center overflow-hidden',
          !backgroundHeight && 'bottom-0'
        )}
        style={backgroundStyle}
      >
        {backgroundContent}
      </div>
      <div
        className={classNames(
          'z-0 absolute top-0 left-0 right-0',
          styles.backgroundGradient,
          !backgroundHeight && 'bottom-0'
        )}
        style={gradientStyle}
      />
      <div className="relative">{children}</div>
    </div>
  );
};
export default BlurredBackgroundSection;
